import { Link } from "@tanstack/react-router";

export function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="max-w-md text-center">
        <h1 className="text-7xl font-bold">404</h1>
        <h2 className="mt-4 text-xl font-semibold">Sidan finns inte</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          Adressen du försökte nå finns inte eller har flyttats.
        </p>
        <Link
          to="/"
          className="press mt-6 inline-flex h-12 items-center rounded-full bg-primary px-6 font-semibold text-primary-foreground"
        >
          Till panelen
        </Link>
      </div>
    </div>
  );
}
